import { SURVEY_REQUEST, SURVEY_SUCCESS } from './types';

export const surveyRequest = () => ({
  type: SURVEY_REQUEST
});

export const surveySuccess = survey => ({
  type: SURVEY_SUCCESS,
  payload: { survey }
});